import React, { useState } from "react";
import systemTrainigBanner from "../../Assets/Images/systemTrainingbanner.png";
import {
  MdKeyboardDoubleArrowDown,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
const ManagementSystemTraining = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const data = [
    {
      title:
        "HACCP Certification – Hazard Analysis and Critical Control Points",
      content:
        " HACCP certification enables your organization to proactively identify, assess, and control food safety hazards, assuring safe products and regulatory confidence throughout the supply chain.",
    },
    {
      title: "SA 8000 Compliance – Social Accountability Standard",
      content:
        "SA 8000 compliance validates your commitment to ethical workplace practices, including fair labor, safe working conditions, and respect for human rights across your operations.",
    },
    {
      title: "GMP Compliance – Good Manufacturing Practices",
      content:
        "GMP compliance guarantees systematic controls in manufacturing processes, ensuring products are consistently produced and controlled to quality standards while meeting legal requirements.",
    },
    {
      title: "GDPR Compliance – General Data Protection Regulation",
      content:
        "GDPR compliance protects personal data, enabling you to process information lawfully, transparently, and securely in accordance with strict European privacy regulations.",
    },
    {
      title: "GDP Compliance – Good Distribution Practice",
      content:
        "GDP compliance ensures best practices for the storage, handling, and distribution of pharmaceuticals, safeguarding product integrity and patient safety throughout the supply chain.",
    },
    {
      title:
        "HIPAA Compliance – Health Insurance Portability and Accountability Act",
      content:
        "HIPAA compliance secures the privacy and security of healthcare data, enabling your organization to protect patient information and uphold regulatory standards in the medical sector",
    },
  ];

  const toggleContent = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container">
      <div>
        <div className=" d-flex justify-content-between align-items-center  management-system-training">
          <p className="system-training-content">
            Our training empowers your team to implement, maintain, and improve
            ISO standards for lasting compliance and continuous improvement. Led
            by industry experts, we ensure practical learning with real-world
            applications
          </p>
          <h1 className="system-training-title">
            OTHER INTERNATIONAL CERTIFICATIONS
          </h1>
        </div>

        <div className="row system-training-banner-section ">
          <div className="col-lg-5 col-sm-12 col-md-12">
            <img
              className="system-training-banner"
              src={systemTrainigBanner}
              alt=""
            />
          </div>
          <div className="col-lg-7 col-sm-12 col-md-12">
            {data.map((item, index) => (
              <div
                key={index}
                className={`training-option ${
                  openIndex === index ? "active" : ""
                }`}
              >
                <div
                  className="training-option-header"
                  onClick={() => toggleContent(index)}
                >
                  {openIndex === index ? (
                    <MdKeyboardDoubleArrowDown
                      size={22}
                      className="training-arrow-icon"
                    />
                  ) : (
                    <MdKeyboardDoubleArrowRight
                      size={22}
                      className="training-arrow-icon"
                    />
                  )}
                  <h2 className="training-title">{item.title}</h2>
                </div>

                {openIndex === index && (
                  <div className="training-management-content">
                    <p>{item.content}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagementSystemTraining;
